<template>
  <v-container fluid>
    <PageTitle title="Data Tables" />

    <ApiDataTable
      ref="data_tables"
      data-api="datatables"
      :toolbar-buttons="[{ title: 'Add Existing Tables', icon: 'mdi-plus' }]"
      @toolbar-button-click="addExit"
      :row-buttons="[
        { text: 'Columns', icon: 'mdi-table-edit' },
        { text: 'Data Rules', icon: 'mdi-filter-plus-outline' },
        { text: 'Edit Data', icon: 'mdi-database-edit-outline' },
      ]"
      @row-button-click="rowButtonClick"
      :can-insert="true"
      :can-update="true"
      :can-delete="true"
    />

    <v-dialog :value="dialog" scrollable width="800">
      <v-card>
        <v-card-title>Columns - {{ table ? table.name : "" }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="pa-0">
          <ApiDataTable
            ref="data_fields"
            data-api="datafields"
            elevation="0"
            :params="params"
            :can-insert="true"
            :can-update="true"
            :can-delete="true"
          />
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn
            v-if="table ? table.linkTable : false"
            color="primary"
            text
            @click="genColumns"
            >Generate Columns</v-btn
          >
          <v-btn color="error" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addExitDialog" scrollable width="800">
      <v-card :loading="addExitDialogLoading" :disabled="addExitDialogLoading">
        <v-card-title>Add Exiting Tables</v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <ConnectionPickere
                  v-model="connectionId"
                  title="Database Connection"
                />
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-list dense>
                  <v-list-item>
                    <div class="title">Select Tables</div>
                  </v-list-item>
                  <v-list-item v-for="item in tables" :key="item" dense>
                    <v-list-item-content>
                      <v-checkbox
                        v-model="selectedTables"
                        :value="item"
                        dense
                        hide-details
                        :label="item"
                      ></v-checkbox>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="selectAll">Select All</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="addExitTables">OK</v-btn>
          <v-btn color="error" text @click="addExitDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="ruleDialog" width="1000">
      <v-card :loading="ruleDialogLoading" :disabled="ruleDialogLoading">
        <v-card-title>Rules - {{ tableName }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text style="height: 500px" class="pa-0">
          <v-container v-if="rules.length > 0" class="pa-0">
            <v-row no-gutters>
              <v-col cols="6">
                <div style="overflow: auto; height: 500px" class="pa-4">
                  <v-card>
                    <v-card-actions>
                      <v-btn
                        :disabled="!editingRule"
                        color="error"
                        text
                        title="Delete Rule"
                        @click="deleteRule"
                      >
                        <v-icon>mdi-close</v-icon>
                        Delete Rule
                      </v-btn>
                    </v-card-actions>
                    <v-divider></v-divider>
                    <v-list class="pa-0">
                      <v-list-item-group>
                        <v-list-item
                          v-for="(item, index) in rules"
                          :key="index"
                          @click="ruleClick(item)"
                        >
                          <v-list-item-icon>
                            <v-icon>mdi-filter-outline</v-icon>
                          </v-list-item-icon>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              item.ruleType
                            }} - {{ item.fieldName }}</v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                      </v-list-item-group>
                    </v-list>
                  </v-card>
                </div>
              </v-col>
              <v-col cols="6">
                <div style="overflow: auto; height: 500px">
                  <v-container v-if="editingRule">
                    <v-row>
                      <v-col cols="12">
                        <v-select
                          filled
                          hide-details
                          label="Rule Type"
                          :items="[
                            'filter',
                            'join',
                            'joinAndFilter',
                            'parameter',
                          ]"
                          v-model="editingRule.ruleType"
                        ></v-select>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          editingRule.ruleType == 'join' ||
                          editingRule.ruleType == 'joinAndFilter'
                        "
                      >
                        <span class="subtitle-1">Join Properties</span>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          editingRule.ruleType == 'join' ||
                          editingRule.ruleType == 'joinAndFilter'
                        "
                      >
                        <ServerFieldPicker
                          title="Join Field (Primary)"
                          :table="tableName"
                          v-model="editingRule.joinField"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          editingRule.ruleType == 'join' ||
                          editingRule.ruleType == 'joinAndFilter'
                        "
                      >
                        <TablePicker
                          title="Join Table"
                          v-model="editingRule.joinTable"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          editingRule.ruleType == 'join' ||
                          editingRule.ruleType == 'joinAndFilter'
                        "
                      >
                        <ServerFieldPicker
                          title="Join Field (FK)"
                          :table="editingRule.joinTable"
                          :disabled="!editingRule.joinTable"
                          v-model="editingRule.joinTableFk"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          editingRule.ruleType == 'filter' ||
                          editingRule.ruleType == 'joinAndFilter'
                        "
                      >
                        <span class="subtitle-1">Filter Properties</span>
                      </v-col>
                      <v-col cols="12" v-if="editingRule.ruleType == 'filter'">
                        <ServerFieldPicker
                          title="Filtered Field"
                          :table="tableName"
                          v-model="editingRule.fieldName"
                          @type-change="editingRule.ruleValueType = $event"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="editingRule.ruleType == 'joinAndFilter'"
                      >
                        <ServerFieldPicker
                          title="Filtered Field"
                          :table="editingRule.joinTable"
                          :disabled="!editingRule.joinTable"
                          v-model="editingRule.fieldName"
                          @type-change="editingRule.ruleValueType = $event"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          editingRule.ruleType == 'filter' ||
                          editingRule.ruleType == 'joinAndFilter'
                        "
                      >
                        <ComparisonPicker
                          title="Filter Comparison"
                          v-model="editingRule.compare"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          editingRule.ruleType == 'filter' ||
                          editingRule.ruleType == 'joinAndFilter'
                        "
                      >
                        <ServerFieldValuePicker
                          title="Filter Value"
                          :table="tableName"
                          v-model="editingRule.ruleValue"
                          :type="editingRule.ruleValueType"
                          @value-type="editingRule.ruleValueType = $event"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="
                          editingRule.ruleType == 'filter' ||
                          editingRule.ruleType == 'joinAndFilter'
                        "
                      >
                        <v-checkbox
                          label="And"
                          hide-details
                          v-model="editingRule.and"
                        ></v-checkbox>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="editingRule.ruleType == 'parameter'"
                      >
                        <span class="subtitle-1">Parameter Properties</span>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="editingRule.ruleType == 'parameter'"
                      >
                        <v-text-field
                          filled
                          hide-details
                          label="Parameter Name"
                          v-model="editingRule.fieldName"
                        ></v-text-field>
                      </v-col>
                      <v-col
                        cols="12"
                        v-if="editingRule.ruleType == 'parameter'"
                      >
                        <ServerFieldValuePicker
                          title="Parameter Value"
                          :table="tableName"
                          v-model="editingRule.ruleValue"
                          :type="editingRule.ruleValueType"
                          @value-type="editingRule.ruleValueType = $event"
                        />
                      </v-col>
                      <v-col cols="12">
                        <span class="subtitle-1">Operation</span>
                      </v-col>
                      <v-col cols="12">
                        <v-checkbox
                          label="Query Rule"
                          hide-details
                          v-model="editingRule.isSelectRule"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <v-checkbox
                          label="Update Rule"
                          hide-details
                          v-model="editingRule.isUpdateRule"
                        ></v-checkbox>
                      </v-col>
                      <v-col cols="12">
                        <v-checkbox
                          label="Delete Rule"
                          hide-details
                          v-model="editingRule.isDeleteRule"
                        ></v-checkbox>
                      </v-col>
                    </v-row>
                  </v-container>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-alert v-else text type="info" class="mt-6">
            Please click add rule button.
          </v-alert>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn text color="primary" title="Add Rule" @click="addRule">
            <v-icon>mdi-plus</v-icon>
            Add Rule
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="saveRules">Save</v-btn>
          <v-btn color="error" text @click="ruleDialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import server from "../../services/server";
import ApiDataTable from "../ui/shared/ApiDataTable.vue";
import ConnectionPickere from "../ui/shared/ConnectionPicker.vue";
import PageTitle from "../ui/shared/PageTitle.vue";
import TablePicker from "../ui/shared/TablePicker.vue";
import ServerFieldPicker from "../ui/shared/ServerFieldPicker.vue";
import ServerFieldValuePicker from "../ui/shared/ServerFieldValuePicker.vue";
import ComparisonPicker from "../ui/shared/ComparisonPicker.vue";

export default {
  name: "Tables",

  components: {
    ApiDataTable,
    ConnectionPickere,
    PageTitle,
    TablePicker,
    ServerFieldPicker,
    ServerFieldValuePicker,
    ComparisonPicker,
  },

  data() {
    return {
      showFieldsDialog: false,
      table: null,
      dialog: false,
      params: { tableId: 0 },
      connectionId: 0,
      tables: [],
      selectedTables: [],
      addExitDialog: false,
      addExitDialogLoading: false,
      ruleDialog: false,
      ruleDialogLoading: false,
      tableId: 0,
      tableName: null,
      editingRule: {},
      rules: [],
    };
  },

  watch: {
    connectionId(v) {
      this.tables = [];
      this.selectedTables = [];

      if (v) {
        server
          .get("datatables/dbtables/" + v)
          .then((response) => (this.tables = response));
      }
    },
  },

  methods: {
    addExitTables() {
      this.addExitDialogLoading = true;

      server
        .post("datatables/addexit/" + this.connectionId, this.selectedTables)
        .then(() => {
          this.$refs.data_tables.refresh();
          this.addExitDialogLoading = false;
          this.addExitDialog = false;
        });
    },
    selectAll() {
      this.selectedTables = [];
      this.tables.forEach((i) => this.selectedTables.push(i));
    },
    addExit() {
      this.addExitDialog = true;
    },
    rowButtonClick({ item, button }) {
      if (button.text == "Data Rules") {
        this.editRules(item);
      } else if (button.text == "Columns") {
        this.editColumns(item);
      } else {
        this.editData(item);
      }
    },
    editData(item) {
      this.$router.push("/admin/tables/" + item.name);
    },
    editColumns(item) {
      this.table = item;
      this.params.tableId = item.tableId;
      this.dialog = true;

      if (this.$refs.data_fields) this.$refs.data_fields.refresh(true);
    },
    genColumns() {
      this.$refs.data_fields.beginLoad();

      server
        .get("datatables/" + this.table.tableId + "/gencolumns")
        .then((response) => {
          this.$refs.data_fields.endLoad();
          this.$refs.data_fields.setRows(response, response.length);
        })
        .catch((err) => {
          this.$refs.data_fields.endLoad();
          alert(err);
        });
    },
    editRules(item) {
      this.ruleDialog = true;
      this.ruleDialogLoading = true;
      this.tableName = item.name;
      this.tableId = item.tableId;
      this.editingRule = null;

      server
        .get("datatables/" + this.tableId + "/rules")
        .then((response) => {
          if (!response) this.serverFilters = [];
          else this.rules = response;
        })
        .finally(() => (this.ruleDialogLoading = false));
    },
    addRule() {
      this.rules.push({
        ruleType: "filter",
        joinField: null,
        joinTable: null,
        joinTableFk: null,
        isSelectRule: true,
        isUpdateRule: true,
        isDeleteRule: true,
        compare: "=",
        and: false,
        fieldName: null,
        ruleValue: null,
        ruleValueType: "text",
      });
    },
    ruleClick(item) {
      this.editingRule = item;
    },
    deleteRule() {
      var index = this.rules.indexOf(this.editingRule);

      if (index > -1) {
        this.rules.splice(index, 1);
        this.editingRule = null;
      }
    },
    saveRules() {
      this.ruleDialogLoading = true;

      server
        .post("datatables/" + this.tableId + "/rules", this.rules)
        .then(() => {
          this.ruleDialog = false;
        })
        .finally(() => (this.ruleDialogLoading = false));
    },
  },
};
</script>